module.exports = fox._r("fonts/robotoslab-regular-webfont.woff", __webpack_public_path__ + "fonts/zvC2XSO.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/robotoslab-regular-webfont.woff
// module id = 587
// module chunks = 2